import { z } from "zod";
import type { CategoryPlugin } from "../plugin";

const schema = z.object({
  format: z.enum(["Vent Clip", "Hanging", "Cartridge", "Gel"]).optional(),
  duration_weeks: z.number().int().positive().optional(),
  refillable: z.boolean().optional(),
});

export const plugin: CategoryPlugin<z.infer<typeof schema>> = {
  metadata: {
    id: "car-perfumes", slug: "car-perfumes", name: "Car Perfumes",
    tagline: "Fragrance for the drive", status: "launched",
  },
  attributeSchema: schema,
  search: { columns: ["name","family","notes"], attributes: ["format"] },
  facets: [
    { key: "format",         label: "Format",         type: "enum",  source: "attribute",
      options: ["Vent Clip","Hanging","Cartridge","Gel"] },
    { key: "family",         label: "Scent family",   type: "enum",  source: "column",
      options: ["Floral","Oriental","Woody","Leather","Chypre","Amber","Green"] },
    { key: "duration_weeks", label: "Duration (wks)", type: "range", source: "attribute",
      min: 1, max: 12, step: 1, unit: "wk" },
    { key: "refillable",     label: "Refillable",     type: "boolean", source: "attribute" },
    { key: "price",          label: "Price (₹)",      type: "range", source: "column",
      min: 10, max: 200, step: 5, unit: "₹" },
  ],
  pdpPanels: [
    { key: "product", label: "Product details", attributes: ["format","duration_weeks","refillable"] },
  ],
  seo: {
    titleTemplate: "{name} · CB16 Car Fragrance",
    descriptionTemplate: "{name} — long-lasting fragrance for the car interior.",
    routePrefix: "car-perfumes",
  },
  adminForm: [
    { key: "format",         label: "Format",         kind: "select",  options: ["Vent Clip","Hanging","Cartridge","Gel"] },
    { key: "duration_weeks", label: "Duration (wks)", kind: "number" },
    { key: "refillable",     label: "Refillable",     kind: "boolean" },
  ],
};
